import {
  Box,
  Heading,
  Text,
  Grid,
  GridItem,
  Link,
  Icon,
} from "@chakra-ui/react";
import Person from "~/components/Person";
import { FaExternalLinkAlt } from "react-icons/fa";

export default function AboutUs() {
  const people = [
    {
      name: "nazan",
      image: "https://avatars.githubusercontent.com/u/69011354?v=4",
    },
    {
      name: "emir",
      image: "https://avatars.githubusercontent.com/u/4889965?v=4",
    },

    {
      name: "sean",
    },
    {
      name: "oktay",
    },
    {
      name: "cagatay",
      image: "https://avatars.githubusercontent.com/u/43769974?v=4",
    },
  ];
  return (
    <Box marginX="auto" p={6} maxW={1200}>
      <Heading mb={10}>About Us</Heading>
      <Text mb={10}>
        Hype.day is powered by{" "}
        <Link isExternal href="https://fractal.capital">
          Fractal Capital <Icon as={FaExternalLinkAlt} ml={2} />
        </Link>
        , developed in Santa Monica, California 🏄
      </Text>
      <Heading mb={10}>Team</Heading>
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(5, 1fr)",
          md: "repeat(5, 1fr)",
        }}
        gap={4}
      >
        {people.map((person) => (
          <GridItem key={person.name}>
            <Person info={person}></Person>
          </GridItem>
        ))}
      </Grid>
    </Box>
  );
}
